exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=text][data-v-3a34641e] {\n  height: auto;\n}\n.input-group-append .icon-close[data-v-3a34641e] {\n  font-size: 0.7rem;\n}", ""]);

// exports
